module.exports = __webpack_public_path__ + "img/top.edc0a01d.png";